export const SET_USER = 'SET_USER';

export const setUser = (user) => (dispatch, getState) => Promise.resolve(dispatch(_setUser(user)));

const _setUser = (user) => ({
    type: SET_USER,
    payload: {
        user
    }
});